export const ESGFNodeList = [
    'aims3.llnl.gov',
    'cmip.dess.tsinghua.edu.cn',
    'cmip.fio.org.cn',
    'crd-esgf-drc.ec.gc.ca',
    'dataserver.nccs.nasa.gov',
    'dpesgf03.nccs.nasa.gov',
    'esg-cccr.tropmet.res.in',
    'esg-dn1.nsc.liu.se',
    'esg-dn2.nsc.liu.se',
    'esg.camscma.cn',
    'esg.lasg.ac.cn',
    'esgdata.gfdl.noaa.gov',
    'esgf-data.csc.fi',
    'esgf-data.ucar.edu',
    'esgf-data1.llnl.gov',
    'esgf-data2.llnl.gov',
    'esgf-nimscmip6.apcc21.org',
    'esgf-node.cmcc.it',
    'esgf-node2.cmcc.it',
    'esgf.bsc.es',
    'esgf.dwd.de',
    'esgf.nci.org.au',
    'esgf.rcec.sinica.edu.tw',
    'esgf1.dkrz.de',
    'esgf3.dkrz.de',
    'noresg.nird.sigma2.no',
    'polaris.pknu.ac.kr',
    'vesg.ipsl.upmc.fr', // CMIP5 and CMIP6
];
